import { lazy, Suspense } from "react";

import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import HdModal from "@hd/ui-kit/hd-modal/HdModal";

import { useMiceQuotationRestoreModalStore } from "./mice-quotation-restore-modal.store";

const MiceQuotationRestoreModalContent = lazy(() => import("./MiceQuotationRestoreModalContent"));

function MiceQuotationRestoreModal() {
  const isOpen = useMiceQuotationRestoreModalStore((state) => state.isOpen);
  const closeModal = useMiceQuotationRestoreModalStore((state) => state.close);

  return (
    <HdModal
      backdrop={true}
      isOpen={isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal();
        }
      }}
      // closeOnClickOutside={false}
      className="p-2 bg-white w-auto  flex flex-col"
    >
      <Suspense fallback={<HdLoader></HdLoader>}>
        <MiceQuotationRestoreModalContent></MiceQuotationRestoreModalContent>
      </Suspense>
    </HdModal>
  );
}

export default MiceQuotationRestoreModal;
